<template>
  <div :class="$style.containerBox">
    <input
      type="text"
      id="phone"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @paste.prevent="onPaste"
    />
  </div>
</template>

<script>
import intlTelInput from "../../../../libs/intlTelInput/js/intlTelInputWithUtils.min.js";
import "../../../../libs/intlTelInput/css/intlTelInput.less";
import * as allLang from "../../../../libs/intlTelInput/js/i18n/index.js";

export default {
  name: "phoneInput",
  props: ['modelValue', 'lang'],
  emits: [
    'update:modelValue',
  ],
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const input = document.querySelector("#phone");
      const iti = intlTelInput(input, {
        strictMode: true,
        separateDialCode: this.modelValue ? false : true,
        nationalMode: true,
        initialCountry: window.GT.user.geo ? window.GT.user.geo : "auto",
        i18n: allLang[this.lang],
      });
      window.iti = iti;
    },
    onPaste(e) {
      const clipboardData = e.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData('text');
      let finalData = pastedData.replace(/[^0-9]/g, '');
      this.$emit('update:modelValue', finalData);
    }
  },
};
</script>

<style lang="less" module>
.containerBox {
  display: flex;
  align-items: center;
  outline: none !important;
  font-size: 14px;
  line-height: 18px;
  font-family: "Lato-Regular", sans-serif;
  font-weight: normal;
  font-style: normal;
  color: #424242;
  width: 100%;
  background-color: #fff;
  min-height: 40px;
  & input {
    border: none;
    border-radius: 4px;
    -webkit-box-shadow: inset 0px 0px 0px calc(1px) #ccc;
    -moz-box-shadow: inset 0px 0px 0px calc(1px) #ccc;
    box-shadow: inset 0px 0px 0px calc(1px) #ccc;
    &:focus {
      border: none;
      -webkit-box-shadow: inset 0px 0px 0px calc(2px) #4484cd;
      -moz-box-shadow: inset 0px 0px 0px calc(2px) #4484cd;
      box-shadow: inset 0px 0px 0px calc(2px) #4484cd;
    }
  }
}
</style>
